import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { environment } from '../../../../../environments/environment';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { PropertyManagementService } from '../../../../shared/providers/property-management.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IDocumentAccessOutputModel } from '../../../../shared/models/DocumentAccessOutputModel';
import { DocAccessStatus, DocumentType } from '../../../../shared/enum/enum';
import { ToastService } from '../../../../shared/providers/toast.service';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { IDocumentAccessInputModel } from '../../../../shared/models/DocumentAccessInputModel';

@Component({
  selector: 'app-portfolio-duediligence-list',
  templateUrl: './portfolio-duediligence-list.component.html',
  styleUrls: ['./portfolio-duediligence-list.component.css']
})
export class DuediligenceComponent implements OnInit {

  @Input() propertyId: number;
  @Input() property: any;
  @Input() docAccessStatus = DocAccessStatus;
  @Input() canEditProperty: boolean;
  dueDiligenceDocList: any[] = [];
  dtoptions = {};
  table: DataTableDirective;
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  DDColumns = [];
  protected readonly BASE_URL: string = environment.base_url;
  user: any;
  utm_id: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
  docPreview: any;
  documentPreview: BsModalRef;
  //defaultCategoryText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Category',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Filter By Category",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  categoryLst = [];
  selectedCategories: number[] = []
  categoryids = [];
  showNodataDD: boolean = false;
  ddRequestRejected: boolean = false;
  pendingApproval: boolean = false;
  showCAAcceptPending: boolean = false;
  shodDocuments: boolean = false;
  isDueDiligenceTandC = false;
  ddRequireApproval: boolean = false;
  ndaDetails = {} as any;
  docAccessInput = {} as IDocumentAccessInputModel;
  docAccessOutput = {} as IDocumentAccessOutputModel;
  isfromSearch: boolean = false;
  IsLoading = false;
  constructor(private http: HttpClient, private loaderService: LoaderService, public Validation: ValidationService,
    private _toastService: ToastService, private _propertyService: PropertyListingService,
    public authService: AuthenticationService, private _propertyManagerService: PropertyManagementService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.user = this.authService.user != null ? this.authService.user : '';
    this.loadDDCategoryTypes(this.propertyId);
    this.loadDueDiligenceData(this.propertyId);
  }

  loadDDCategoryTypes(propertyid) {
    this._propertyManagerService.getDataEntryStaffDocumentCategoryIds(propertyid).subscribe(response => {
      this.categoryLst = response.map(o => {
        return {
          id: o.CategoryId, name: o.Category
        };
      });
    });
  }

  onSearch(text: string) {
    ;
    this.isfromSearch = true;
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }


  redrawTable() {
    this.dtElement.dtInstance.then(x => x.draw(false));
  }

  loadDueDiligenceData(propertyid) {
    this.DDColumns = [
      { data: 'Name', orderable: false },
      { data: 'DisplayName', orderable: false },
      { data: 'UploadedDate' },
      { data: 'Category' },
      { data: 'Name', orderable: false }]


    const that = this;

    this.dtoptions = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[2, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          DocumentCategories: that.categoryids,
          IsDataEntryProperty: true,
          IsPortfolioProperty: true
        }

        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/GetDueDiligenceDocuments/' + propertyid, dataTablesParameters).subscribe(resp => {
            if (resp != null) {
              this.dueDiligenceDocList = resp.data ? resp.data : [];
              setTimeout(() => { this.showDDDocuments(); }, 10);
              this.loaderService.display(false);
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
        this.loaderService.display(false);
      },
      columns: that.DDColumns
    };
  }

  onDueDiligenceProceedClick() {

    this.loaderService.display(true);
    this.docAccessOutput.RequestForDueDiligenceAccessId = this.property.DueDiligenceReqApproval ? DocAccessStatus.Pending : DocAccessStatus.New;
    this.docAccessOutput.IsPrincipal = true;
    this.docAccessOutput.DocumentType = DocumentType.DueDiligenceDocAccess;
    var userId = this.user.Id;
    this.docAccessOutput.LoggedinUserId = userId
    this.docAccessOutput.IsCAAccepted = this.isDueDiligenceTandC || this.docAccessOutput.IsCAAccepted;
    this._propertyService.saveAccessRequestForDocuments(this.docAccessOutput).subscribe(response => {
      if (response != null) {
        if (this.docAccessOutput.RequestForDueDiligenceAccessId == DocAccessStatus.Pending) {
          this._toastService.addToast({ title: 'Success', msg: "You can download the due diligence documents after admin approval", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this._toastService.addToast({ title: 'Success', msg: "You can download the due diligence documents", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
      }
      this.showCAAcceptPending = false;
      this.showNodataDD = false;
      this.pendingApproval = true;
      this.loaderService.display(false);
    });
  }

  showDDDocuments() {
    var show = false;
    if (this.dueDiligenceDocList == null || this.dueDiligenceDocList.length == 0) {
      if ((this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Accepted && !this.canEditProperty))
        show = !this.DDDocumentDisplayConditions();
    }

    if (this.dueDiligenceDocList.length > 0 && this.dueDiligenceDocList != null) {

      show = this.DDDocumentDisplayConditions();
    }
    else {
      this.showNodataDD = this.DDDocumentDisplayConditions();
    }

    if (this.property.DDConfidentialityAgreement == true && !this.docAccessOutput.IsCAAccepted && !this.canEditProperty) {

      show = true;
      this.showNodataDD = false;
      this.showCAAcceptPending = true;
    }

    if (this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.New && !this.canEditProperty) {
      show = true
      this.showNodataDD = false;
      this.ddRequireApproval = true;
    }

    if ((!this.property.DDConfidentialityAgreement || this.docAccessOutput.IsCAAccepted == true)) {
      if (this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Pending && !this.canEditProperty) {
        show = true;
        this.showNodataDD = false;
        this.pendingApproval = true;
      }
    }

    if ((!this.property.DDConfidentialityAgreement || this.docAccessOutput.IsCAAccepted == true)) {
      if (this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Rejected && !this.canEditProperty) {
        show = true;
        this.showNodataDD = false;
        this.ddRequestRejected = true;
      }
    }
    return show;
  }

  DDDocumentDisplayConditions() {
    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
      return true;
    }
    else {
      if (this.property.DDConfidentialityAgreement == true && this.property.DueDiligenceReqApproval != true) {
        if (this.docAccessOutput.IsCAAccepted == true) {
          return true;
        }
        else {
          return false;
        }
      }

      if (this.property.DDConfidentialityAgreement != true && this.property.DueDiligenceReqApproval != true) {
        return true;
      }
      if (this.property.DDConfidentialityAgreement != true && this.property.DueDiligenceReqApproval == true) {
        if (this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Accepted) {
          return true
        }
        else {
          return false;
        }
      }
      if (this.property.DueDiligenceReqApproval == true && this.docAccessOutput.IsCAAccepted == true) {
        if (this.property.DueDiligenceReqApproval != true) {
          return true;
        }
        else {
          if (this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Accepted) {
            return true
          }
          else {
            return false;
          }
        }
      }
      else {
        return false;
      }
    }
  }

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }


  saveDueDiligenceToAuditLog() {

    var propertyId = this.propertyId
    var userId = this.user.Id;
    var constData = {
      UtmId: this.utm_id,
      UtmSource: this.utm_source,
      UtmMedium: this.utm_medium,
      UtmCampaign: this.utm_campaign,
      UtmTerm: this.utm_term,
      UtmContent: this.utm_content,
      Propertyid: propertyId,
      UserId: userId
    };
    this._propertyManagerService.saveDueDiligenceToAuditLog(constData).subscribe(response => {
    });
  }

}
